import NavBar from './nav_bar/navBar';

function App() {
  return (<NavBar />);
}

export default App;
